module.exports = __webpack_public_path__ + "static/media/Leopard869_3c.384554fa.svg";